import React from 'react';
import {Column, DescriptiveText, Icon, Row} from '../../../shared';

const WealthAlerts = () => (
  <Column height={'100%'} justifySubColumn={'center'}>
    <Row>
      <Icon height={'60px'} width={'60px'} svg={'thumbsUp'}/>
    </Row>
    <Row>
      <DescriptiveText fontSize={'18px'} alignment={'center'} margin={'20px 15px 0 15px'}>
        You currently do not have any WealthAlerts.
      </DescriptiveText>
    </Row>
  </Column>
);

export default WealthAlerts;

WealthAlerts.propTypes = {};
